import { EndpointsOptionsMap } from '../system';
import * as signUpApi from './signup';

export type SignUpApiEndpointTypes = EndpointsOptionsMap<typeof signUpApi>;
export { signUpApi };
